import { lazyLoad } from "utils/loadable";

export const EmployerAccessPrivileges = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerAccessPrivileges
);
